import { useTranslation } from 'react-i18next';

import { EMAIL_PLATFORMS } from '@this+that/constants';
import {
  AppSidebarShell,
  SidebarItemsSlot,
  SidebarLogo,
  useAppSidebarState,
  useSidebarShellStore,
} from '@this+that/ui';

import { ComposeButton, ComposeDropdownMenu } from './components';
import { useComposeButtonAction } from './hooks';
import { SidebarTeamSwitcher } from './SidebarTeamSwitcher/SidebarTeamSwitcher';
import { useSidebarConfig } from './sidebar.config';
import { APP_PAGES } from '../../routes/constants';
import { useIntegrationsStore } from '../../store';
import { useCreateDoBoxFormStore } from '../../store/CreateDoBoxForm/useCreateDoBoxFormStore';

export function Sidebar() {
  const { t } = useTranslation();
  const state = useAppSidebarState();
  const { integrationAccounts, isLoading: isLoadingIntegrations } =
    useIntegrationsStore();
  const { handleClick } = useComposeButtonAction();
  const { sidebarItems, footerItems } = useSidebarConfig(t);

  const hasEmailAccounts =
    integrationAccounts.filter((account) =>
      EMAIL_PLATFORMS.includes(account.platform),
    ).length > 0;

  const closeDrawerOnMobile = () => {
    if (state.isMobile) {
      useSidebarShellStore.getState().setOpen(false);
    }
  };

  const handleCreateTask = () => {
    useCreateDoBoxFormStore.getState().open();
    closeDrawerOnMobile();
  };

  const handleCompose = () => {
    handleClick();
    closeDrawerOnMobile();
  };

  const composeSlot = (
    <>
      {hasEmailAccounts && (
        <ComposeButton
          onClick={handleCompose}
          isLoading={isLoadingIntegrations}
          isOpen={state.shouldShowExpanded}
          text={t('components.composeButton.compose')}
        />
      )}
      <ComposeDropdownMenu
        hasEmailAccounts={hasEmailAccounts}
        isExpanded={state.shouldShowExpanded}
        isLoading={isLoadingIntegrations}
        onCreateTask={handleCreateTask}
      />
    </>
  );

  const headerSlot = <SidebarTeamSwitcher isOpen={state.shouldShowExpanded} />;

  return (
    <AppSidebarShell
      logoSlot={
        <SidebarLogo href={APP_PAGES.INBOX} label={t('common.sidebar.logo')} />
      }
      {...state}
      toggleAriaLabel={t('aria-labels.openSidebar')}
      headerSlot={headerSlot}
      composeSlot={composeSlot}
      bodySlot={<SidebarItemsSlot items={sidebarItems} {...state} />}
      footerSlot={<SidebarItemsSlot items={footerItems} {...state} />}
    />
  );
}
